module.exports = __webpack_public_path__ + "static/media/banner-ebook.5d641fe9.png";